export enum ENUM__field_store_interaction {
  NONE = 'NONE',
  //
  ONLY_READ_FROM_STORE = 'ONLY_READ_FROM_STORE',
  ONLY_WRITE_TO_STORE = 'ONLY_WRITE_TO_STORE',
  //
  READ_AND_WRITE = 'READ_AND_WRITE',
}
